module.exports = __webpack_public_path__ + "img/check.ebd86ca2.svg";